/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, ClassNames } from '@emotion/react'
import cn from 'classnames'
import { TableCell } from '@mui/material'
import DragIndicator from '@mui/icons-material/DragIndicator'
import { TableHeaderProps } from 'react-table'
import { EnhancedHeader } from '../../../types'
import { ACTION_COLUMN_ID, CELL_PADDING } from '../DataTable'
import SortIndicator from './SortIndicator'

interface Props<D extends object> {
  className?: string
  flexLayoutEnabled: boolean
  header: EnhancedHeader<D>
  headerProps: Omit<TableHeaderProps, 'key'>
}

export default function HeaderCell<D extends object>({ className, flexLayoutEnabled, header, headerProps }: Props<D>) {
  const { className: headerPropsClassName, style, ...restOfProps } = headerProps

  return (
    <ClassNames>
      {({ css, cx }) => (
        <TableCell
          {...restOfProps}
          component="div"
          variant="head"
          css={cx(
            // @ts-ignore
            css(style),
            css`
              && {
                display: flex;
                box-sizing: border-box;
                padding: ${CELL_PADDING}px;
              }
            `,
            !flexLayoutEnabled &&
              header.minWidth !== undefined &&
              css`
                min-width: ${header.minWidth}px;
              `,
            !flexLayoutEnabled &&
              header.maxWidth !== undefined &&
              css`
                max-width: ${header.maxWidth}px;
              `,
            header.id.includes(ACTION_COLUMN_ID) &&
              css`
                flex: none;
              `
          )}
          className={cn(headerPropsClassName, className, `col-${header.id}`)}
        >
          <div
            css={cx(css`
              position: relative;
              display: flex;
              flex-direction: row;
              justify-content: ${header.columns != null ? 'center' : 'flex-start'};
              align-items: center;
              width: 100%;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            `)}
          >
            <span
              css={cx(css`
                font-weight: 600;
                flex: none;
              `)}
            >
              {/** @ts-ignore */}
              {header.render('Header')}
            </span>
            <SortIndicator canSort={header.canSort} isSorted={header.isSorted} isSortedDesc={header.isSortedDesc} />
            {header.id !== ACTION_COLUMN_ID && !header.id.includes('_placeholder') && !!header.getResizerProps && (
              <DragIndicator
                css={css`
                  position: absolute;
                  right: 0;
                  top: 50%;
                  transform: translate(-50%, -50%);
                  color: #b2b2b2;
                  background-color: white;
                `}
                {...header.getResizerProps()}
              />
            )}
          </div>
        </TableCell>
      )}
    </ClassNames>
  )
}
